export default __webpack_public_path__ + "static/media/king.73eee63e.png";